/**
 * v2 mock — shared scroll-reveal utility.
 * Opt in per-element with `data-reveal`. Add `data-reveal-stagger` to stagger
 * siblings inside the nearest `[data-reveal-group]` ancestor.
 * Purely additive: elements without JS or under prefers-reduced-motion just
 * render normally (see the [data-reveal] CSS rule, gated the same way).
 */
(function () {
  if (window.__wwScrollRevealInit) return;
  window.__wwScrollRevealInit = true;

  // Fail-safe: CSS only hides [data-reveal] when this class is present. If this
  // module never runs (e.g. the Instagram in-app webview) or the browser lacks
  // IntersectionObserver, content stays fully visible rather than being stuck
  // at opacity:0. Only opt into the hidden-then-reveal treatment once we know
  // we can actually reveal it.
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('ww-js-reveal');

  var groupCounters = new WeakMap();

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  function observeAll(root) {
    (root || document).querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.hasAttribute('data-reveal-observed')) return;
      el.setAttribute('data-reveal-observed', '');

      if (el.hasAttribute('data-reveal-stagger')) {
        var group = el.closest('[data-reveal-group]') || document.body;
        var count = groupCounters.get(group) || 0;
        el.style.transitionDelay = count * 80 + 'ms';
        groupCounters.set(group, count + 1);
      }

      observer.observe(el);
    });
  }

  window.wwScrollReveal = { observeAll: observeAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeAll(document);
    });
  } else {
    observeAll(document);
  }
})();
